































































































import { Component, Ref, Mixins } from "vue-property-decorator";
import { getMessageList } from "@/api/message";
import { sleep } from "@/utils";
import PageMixin from "@/mixins/page";
import TableAlert from "@/components/TableAlert";
import { ElTable } from "element-ui/types/table";
import { MsgItem, MsgList } from "@/types/message";
import { paginationType, getPageParamsType } from "@/types/element";
import FePage from "@/components/Pagination";

@Component({
  components: { TableAlert, FePage },
})
export default class MessageList extends Mixins(PageMixin) {
  pagination!: paginationType;
  getPageParams!: getPageParamsType;
  search = "";
  loading = false;
  selectNum = 0;
  type = 0;
  unread = 0;
  readType = 0;
  columWidth = [500];
  tableHead = [
    { name: "content", label: "消息内容" },
    { name: "type", label: "消息类型" },
    { name: "subType", label: "消息子类型" },
    { name: "receiveTime", label: "接收时间" },
  ];
  tableData = [];
  @Ref("multipleTable") readonly multipleTableEle!: ElTable;
  get filterData(): MsgList {
    const { tableData, search } = this;
    return tableData.filter(
      (data: MsgItem) =>
        !search || data.content.toLowerCase().includes(search.toLowerCase())
    );
  }

  mounted(): void {
    this.getMessageList();
  }
  async getMessageList(
    page?: undefined | Record<string, unknown>
  ): Promise<unknown> {
    this.loading = true;
    const { type, readType } = this;
    const defaultParams = {
      type,
      readType,
    };
    const params = this.getPageParams(defaultParams, page);
    const [err, res] = await getMessageList(params);
    if (!err && res) {
      await sleep(1000);
      this.tableData = res.data;
      this.unread = res.unread;
      if (this.pagination) this.pagination.total = res.total;
      this.loading = false;
    }
    return;
  }

  async changeReadType(type: number): Promise<unknown> {
    this.readType = type;
    await this.$nextTick();
    return this.getMessageList();
  }

  handleSelectionChange(v: []): void {
    this.selectNum = v.length;
  }
  clearSelection(): void {
    this.multipleTableEle.clearSelection();
  }
}
